export const FieldType = {
    Text: 'text',
    Number: 'number',
    TextArea: 'textarea',
    Html: 'html',
    Image: 'image',
    Parameter: 'parameter',
    Group: 'group',
    Select: 'select'
};